import React, { useContext } from 'react';
import { Radio } from 'antd';

// Import context
import { ProvisioningProductsContext } from '../ProvisioningProductsProvider';

const Tabs = () => {
	const {
		handleTabChange,
		modal: { selectedType, tabs }
	} = useContext(ProvisioningProductsContext);
	return (
		<Radio.Group onChange={handleTabChange} value={selectedType}>
			{tabs.map((tab, index) => (
				<Radio.Button key={`title-${index}`} value={tab.type}>
					{tab.title}
				</Radio.Button>
			))}
		</Radio.Group>
	);
};

export default Tabs;
